/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useState } from 'react';
import i18n from 'i18next';

// Component imports
import { Row, Col, Typography } from 'antd';

// Misc imports
import emptyImage1 from '../../assets/illustrations/emptyImage1.svg';
import emptyImage2 from '../../assets/illustrations/emptyImage2.svg';
import emptyImage3 from '../../assets/illustrations/emptyImage3.svg';
import emptyImage4 from '../../assets/illustrations/emptyImage4.svg';
import emptyImage5 from '../../assets/illustrations/emptyImage5.svg';

const stateItems = [
  {
    image: emptyImage1,
    title: i18n.t('Congratulations!'),
    subtitle: i18n.t('You’ve conquered the chats mountain!')
  },
  {
    image: emptyImage2,
    title: i18n.t('Congratulations!'),
    subtitle: i18n.t('Embrace the ghostly quietness!')
  },
  {
    image: emptyImage3,
    title: i18n.t('Good work!'),
    subtitle: i18n.t('Your lightning-fast responses deserve a round of applause!')
  },
  {
    image: emptyImage4,
    title: i18n.t('Good work!'),
    subtitle: i18n.t('Enjoy the peaceful silence in there!')
  },
  {
    image: emptyImage5,
    title: i18n.t('Well done!'),
    subtitle: i18n.t('Keep up the fantastic work!')
  },
  {
    image: emptyImage4,
    title: i18n.t('Well done!'),
    subtitle: i18n.t('Your expert handling of chats deserves a moment of zen!')
  }
];

let lastRandomIndex = -1;

const getRandomEmptyState = () => {
  let randomIndex;

  // Ensure the new random index is different from the last to avoid repetitiveness
  do {
    randomIndex = Math.floor(Math.random() * stateItems.length);
  } while (randomIndex === lastRandomIndex);

  lastRandomIndex = randomIndex;
  return stateItems[randomIndex];
};

const MessengerEmptyState = () => {
  const [emptyState] = useState(getRandomEmptyState());

  return (
    <Row
      align="middle"
      justify="center"
      className="flex-column h-100"
    >
      <img
        src={emptyState.image}
        alt="Empty state illustration"
        className="svg"
      />

      <Col className="mt-4">
        <Typography.Title level={1} className="mt-3 mb-1">{emptyState.title}</Typography.Title>
      </Col>

      <Col>
        <Typography.Title level={4} className="text-secondary">{emptyState.subtitle}</Typography.Title>
      </Col>
    </Row>
  );
};

export default MessengerEmptyState;
